/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useRef } from "react";
import AppModal from "../feedBacks/AppModal";
import { CARD_TITLE } from "../../utils/constants";
import { ButtonType } from "../../enums/componentEnums";
import AnimatedInput from "../Inputs/AppAnimatedInput";
import AppButton from "../Inputs/AppButton";
import * as Yup from "yup";
import useCustomFormik from "../../customHooks/useFormik";
import { usePostData } from "../../customHooks/usePostData";
import { enqueueSnackbar } from "notistack";
import { IHierarchicalNode } from "../../utils/interfaces";
import { useQueryClient } from "@tanstack/react-query";
import HierarchicalSelector from "../Dashboards/Manager/Selector";

import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import React from "react";
import Loader2 from "../feedBacks/loader2";

function AddLevelModal({
  isModalOpen,
  closeModal,
  enableOutsideClick = true,
  company_id,
  type,
  data,
  classfificationLoading = false,
  classificationError = "",
}: // data
{
  isModalOpen: boolean;
  closeModal: () => void;
  enableOutsideClick?: boolean;
  company_id?: string;
  type: "add" | "edit";
  data?: IHierarchicalNode;
  classfificationLoading?: boolean;
  classificationError?: string;
    }) {
  const queryClient = useQueryClient();
  const [showResults, setShowResults] = useState(false);
  const searchContainerRef = useRef<HTMLDivElement>(null);
  const [classficationId, setClassficationId] = React.useState<string>("");

  const initialValues =
    type === "edit" && data
      ? {
          ...data,
        }
      : {
          name: "",
          level_name: "",
          parent_id: "",
          company_id: company_id,
        };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    level_name: Yup.string().required("Level name is required"),
    company_id: Yup.string().required("Company ID is required"),
    parent_id: Yup.string().optional(),
  });

  const onSubmit = (values: any) => {
    mutate(values);
  };

  const {
    handleSubmit,
    values,
    getFieldProps,
    errors,
    touched,
    isSubmitting,
    resetForm,
    setSubmitting,
    setValues,
  } = useCustomFormik({ initialValues, validationSchema, onSubmit });
  const handleClassificationChange = (e: any) => {
    // setisClassificationLoading(true);
    setValues({ parent_id: e.id });
    setClassficationId(e);
  };
  const { mutate } = usePostData(
    type === "edit" ? `/classifications/${data?.id}` : "/classifications/",
    type === "edit" ? "PUT" : "POST",
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: [
            "/classifications",
            "fetchAssetClassifications",
            data.company.id,
          ],
        });

        enqueueSnackbar(
          type === "edit" ? "Level updated" : "New Level added!",
          {
            variant: "success",
          }
        );
        resetForm();
        setSubmitting(false);
        closeModal();
      },
      onError: (err) => {
        const errorMessages = Object.values(err.response?.data || {})
          .flat() // Flatten arrays of errors
          .join(" "); // Join all messages into a single string
        enqueueSnackbar(
          errorMessages || type === "edit"
            ? "Error updating level"
            : "Error adding level",
          {
            variant: "error",
          }
        );
        setSubmitting(false);
      },
    }
  );

  useEffect(() => {
    if (type === "edit" && data) {
      setValues({
        ...data,
        company_id: data.company_id,
      });
    }
  }, [data, type, setValues]);

  // jQuery to handle click outside search results
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target as Node)
      ) {
        setShowResults(false);
      }
    }

    // Add event listener when dropdown is shown
    if (showResults) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showResults]);

  return (
    <AppModal
      isOpen={isModalOpen}
      onClose={closeModal}
      closeOnOutsideClick={enableOutsideClick} // Enable/disable outside click close
    >
      <h2 className={CARD_TITLE}>
        {type === "edit" ? "Edit Level" : "Add new Level"}
      </h2>

      <form onSubmit={handleSubmit} className="gap-4 flex flex-col items-start">
        <AnimatedInput
          placeholder="Name"
          {...getFieldProps("name")}
          value={values.name}
          isErrored={!!errors.name}
          isTouched={!!touched.name}
          errorMessage={errors.name}
        />
        <AnimatedInput
          placeholder="Level Name"
          {...getFieldProps("level_name")}
          value={values.level_name}
          isErrored={!!errors.level_name}
          isTouched={!!touched.level_name}
          errorMessage={errors.level_name}
        />
        <div
          className={`w-full h-[3rem] gap-0 mb-6 relative flex flex-col items-start justify-center border border-primary-border rounded-lg max-h-[80%] p-2 `}
        >
          <span className="absolute top-[-20px] left-2 bg-white px-2 py-1 text-sm text-primary-blackMain font-semibold">
            Parent
          </span>
          {data && (
            <HierarchicalSelector
              data={data as any}
              selectedId={classficationId}
              onSelect={handleClassificationChange as any}
              className="!relative !w-full !h-[2rem] !bg-white !rounded-none !p-0 !border-none"
              modalStyle="mt-[-10px] !left-0"
            />
          )}
          {classfificationLoading ? (
            <div className="">
              <Loader2 />
            </div>
          ) : classificationError ? (
            <span className="text-primary-red text-sm font-semibold">
              {classificationError}
            </span>
          ) : null}
          {errors.parent_id && (
            <span className="text-xs text-red-500 mt-1">
              {errors.parent_id as string}
            </span>
          )}
        </div>
        <AppButton
          className={"w-full mt-4"}
          text={
            isSubmitting ? "" : type === "edit" ? "Save Changes" : "Add Level"
          }
          loader={{ loading: isSubmitting, height: 4, width: 4 }}
          type={ButtonType.PRIMARY}
          handleClick={handleSubmit}
          disabled={isSubmitting}
        />
      </form>
    </AppModal>
  );
}

export default AddLevelModal;
